<div class="row" style="padding-top: 100px;">
  <div class="col-sm-1"></div>
  <div class="col-sm-10"></div>
  <div class="col-sm-1"></div>
</div>
<div class="container" style="padding-right: 50px; max-width: 93.5%;">
  <div class="row" style="margin-right: 174px;">
    <div
      class="col-md-5 pull-right hidden-xs hidden-sm"
      style="float: left !important; margin-left: -10px;"
    >
      <div class="yCmsContentSlot login-right-content-slot">
        <div class="yCmsComponent login-right-content-component">
          <div class="banner__component simple-banner">
            <a style="display: block;">
              <img
                style="
                  width: 379px;
                  height: 529px;
                  top: -13.38px;
                  left: 7.4px;
                  margin-top: 49px;
                  border-radius: 20px;
                "
                title="login image"
                alt="login image"
                src="assets/img/syarat&ketentuan.png"
                width="20px"
                height="20px"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6" style="margin-top: 38px; margin-left: 15px;">
      <div
        class="yCmsContentSlot regist-left-content-slot js-regist-slot"
        style="margin-right: 10px; display: flex; flex-direction: column;"
      >
        <div
          class="yCmsComponent syarat-left-content-component"
          style="order: 2;"
        >
          <div class="tnc-section">
            <div>
              <div>
                <div>
                  <h3
                    class="title-tnc"
                  >
                    Syarat & Ketentuan
                  </h3>
                </div>
                <div
                  class="row-syarat"
                >
                  <p class="update-tnc"
                  >
                    Update Terakhir: 11 November 2021
                  </p>
                </div>
                <div class="row-syarat">
                  <p class="penting-tnc"
                  >
                    Penting: Harap baca dengan seksama dan pahami syarat dan
                    ketentuan ini (“Ketentuan”). Syarat dan ketentuan ini
                    mengandung batasan-batasan tentang kewajiban Sukanda OneLink
                    dan Ketentuan lain yang mempengaruhi hak-hak hukum anda.
                  </p>
                </div>
                <div class="row-syarat">
                  <p
                  class="content-tnc"
                  >
                    Mohon untuk membaca Syarat dan Ketentuan Penggunaan yang
                    tertulis di bawah ini dengan seksama sebelum mengakses situs
                    <a href="https://www.sukandaonelink.com/" style="text-decoration: none;"
                      ><b style="text-decoration: none; color: #737b7d;"
                        >www.sukandaonelink.com</b
                      ></a
                    >
                    dan/atau aplikasi Sukanda OneLink (<b>“Platform”</b>)
                    dan/atau menggunakan layanan dari Sukanda OneLink. Bahwa
                    dengan menggunakan platform Kami, Anda menyatakan telah
                    membaca, memahami dengan seksama, dan menyetujui untuk
                    terikat dengan Syarat dan Ketentuan Penggunaan ini (“Syarat
                    dan Ketentuan”), serta Platform ini tidak dimaksudkan untuk
                    digunakan oleh, atau ditargetkan untuk, siapa pun di bawah
                    usia 17 tahun. Anda harus berusia setidaknya 17 tahun untuk
                    menggunakan Platform ini. Jika Anda belum berusia 17 tahun,
                    maka Anda harus meninjau kembali Syarat dan Ketentuan ini
                    dengan orang tua atau wali Anda dan mereka harus memahami
                    dan menyetujui persyaratan ini agar Anda dapat menggunakan
                    Platform ini.
                  </p>
                </div>
                <div class="row-syarat">
                  <p class="content-tnc"
                  >
                    Dengan tetap mengakses Platform dan/atau menggunakan
                    aplikasi Sukanda OneLink, Anda telah setuju untuk terikat
                    pada Syarat dan Ketentuan ini:
                  </p>
                </div>
                <div class="row-syarat">
                  <p class="title-content"
                  >
                    Pendahuluan
                  </p>
                </div>

                <div class="row-syarat">
                  <p class="content-tnc"
                  >
                    PT Sukanda Djaya dan afiliasinya, yang selanjutnya akan
                    disebut sebagai <b>Sukanda OneLink</b> atau “<b>Kami</b>”
                    atau “<b>Kita</b>” adalah perseroan terbatas yang didirikan
                    berdasarkan hukum Indonesia, yang berdomisili di Jakarta
                    Utara, yang merupakan penyedia dan operator dari Platform
                    Kami. Sukanda OneLink menyediakan Platform ini dengan tujuan
                    untuk mengembangkan dan mengoperasikan sebuah online
                    marketplace yang menyediakan layanan berupa pembelian dan
                    pengiriman produk-produk yang didistribusikan oleh PT
                    Sukanda Djaya (“<b>Layanan</b>”).
                  </p>
                </div>
                <div class="row-syarat">
                  <p class="content-tnc"
                  >
                    Dengan menerima ketentuan dan persyaratan ini, Anda memahami
                    dan menyetujui bahwa, sebagaimana dinyatakan dalam bagian
                    Pembatasan Tanggung Jawab dan Ganti Rugi, Anda melepaskan
                    hak Anda untuk menyelesaikan setiap perselisihan melalui
                    proses lain yang dapat tersedia untuk Anda, seperti tindakan
                    pengadilan atau proses administrasi.
                  </p>
                </div>
                <div class="row-syarat">
                  <p
                  class="title-content"
                  >
                    Pembuatan dan Penggunaan Akun
                  </p>
                </div>
                <div class="row-syarat">
                  <ol
                   class="content-tnc"
                  >
                    <li>
                      Sebelum melakukan pemesanan dalam Platform, Anda wajib
                      mendaftarkan diri dengan memasukkan informasi pribadi Anda
                      yang diminta termasuk, namun tidak terbatas pada alamat
                      email dan kode sandi, serta username (username didapatkan
                      melalui request kepada tim Kami terlebih dahulu).
                    </li>
                    <li>
                      Satu (1) akun dapat mendaftarkan beberapa alamat email dan
                      akun tersebut hanya dapat merepresentasikan satu (1)
                      alamat pengiriman sebagaimana yang telah didaftarkan
                      sebelumnya kepada Kami.
                    </li>
                    <li>
                      Dengan memasukkan informasi pribadi tersebut, Anda
                      menjamin bahwa seluruh informasi tersebut benar dan
                      lengkap, serta wajib mengirimkan permintaan atau
                      menginformasikan perubahan informasi/data seperti email
                      dan perubahan alamat kirim kepada Kami apabila terdapat
                      perubahan dari informasi/data yang telah Anda berikan.
                    </li>
                    <li>
                      Apabila Anda mendaftarkan atas nama suatu badan hukum atau
                      badan usaha lainnya, Anda menyatakan dan menjamin bahwa
                      Anda berwenang bertindak untuk dan atas nama badan hukum
                      atau badan usaha tersebut, serta mengikat.
                    </li>
                    <li>
                      Hanya Anda yang dapat menggunakan akun Anda sendiri dan
                      Anda berjanji untuk tidak memberikan wewenang kepada orang
                      lain untuk menggunakan identitas Anda atau menggunakan
                      akun Anda. Anda tidak dapat menyerahkan atau mengalihkan
                      akun Anda kepada pihak lain.
                    </li>
                    <li>
                      Kami tidak bertanggung jawab atas seluruh resiko dan
                      kerugian yang timbul sebagai akibat dari penyalahgunaan
                      akun Anda oleh pihak lain yang disebabkan oleh penyerahan
                      dan pengalihan informasi akun Anda kepada pihak lain,
                      termasuk namun tidak terbatas pada meminjamkan atau
                      memberikan akses akun Anda kepada pihak lain, mengakses
                      link atau tautan yang diberikan oleh pihak lain,
                      memberikan atau memperlihatkan kode sandi dan/atau email
                      kepada pihak lain.
                    </li>
                    <li>
                      Anda berjanji hanya akan menggunakan Platform untuk tujuan
                      yang dimaksud untuk mendapatkan Layanan yang tersedia.
                      Anda tidak boleh menyalahgunakan atau menggunakan Platform
                      untuk melakukan penipuan atau menyebabkan ketidaknyamanan
                      terhadap orang lain atau melakukan pemesanan palsu.
                    </li>
                  </ol>
                </div>
                <div class="row-syarat">
                  <p
                  class="title-content"
                  >
                    Informasi dan Keamanan Platform
                  </p>
                </div>
                <div class="row-syarat">
                  <ol
                   class="content-tnc"
                  >
                    <li>
                      Kami melakukan manajemen informasi dan keamanan Platform
                      dengan berusaha menjaga seluruh Layanan, mulai dari
                      pemesanan sampai pembayaran dalam Platform seaman mungkin
                      dan terbebas dari gangguan dari pihak-pihak yang tidak
                      bertanggung jawab.
                    </li>
                    <li>
                      Terlepas dari usaha maksimal yang diberikan, Kami tidak
                      dapat menjamin bahwa pada Platform akan selalu bebas dari
                      kesalahan dan penggunaannya selalu sesuai dengan tujuan,
                      tepat waktu dan setiap kesalahan akan dikoreksi, bebas
                      dari virus atau bug atau menunjukkan keseluruhan fungsi,
                      akurasi, keandalan Platform tersebut.
                    </li>
                    <li>
                      Kami tidak bertanggung jawab untuk setiap keterlambatan,
                      kegagalan, kesalahan, atau kerugian saat pemakaian Layanan
                      kami yang ditimbulkan karena penggunaan internet dan
                      komunikasi elektronik yang tidak kompatibel, atau hal-hal
                      lain yang merusak yang dikirimkan ke sistem komputer milik
                      Anda melalui Platform Kami.
                    </li>
                    <li>
                      Kami tidak akan bertanggung jawab atas segala kerugian
                      yang disebabkan oleh pihak-pihak lain yang mengakses akun
                      Anda tanpa izin dan kewenangan dari Anda, serta hal-hal
                      yang bukan terjadi karena kesalahan/kelalaian dari Kami.
                    </li>
                    <li>
                      Kami mengumpulkan dan memproses informasi pribadi Anda,
                      seperti nama, alamat surat elektronik, dan nomor telepon
                      seluler Anda ketika Anda mendaftar di Platform dan juga
                      Layanan yang tersedia di dalamnya. Anda harus memberikan
                      informasi yang akurat dan lengkap, memperbaharui informasi
                      dan setuju untuk memberikan bukti identitas apapun yang
                      secara wajar diminta oleh Kami.
                    </li>
                    <li>
                      Anda mengerti bahwa ketika menggunakan Platform dan
                      seluruh Layanan Kami, data pribadi Anda dapat dikumpulkan,
                      digunakan dan/atau diungkapkan oleh Kami sehingga Anda
                      dapat menikmati Platform dan Layanan Kami. Hanya untuk
                      tujuan operasi Platform, buletin (newsletter) dan
                      penggunaan layanan dan/atau tujuan lain yang dianggap
                      pantas, Anda dengan ini memberikan persetujuan kepada Kami
                      untuk mengumpulkan, menggunakan, atau mengungkapkan setiap
                      dan seluruh data pribadi Anda yang Anda mengerti bahwa
                      bagian dari data atau informasi mengenai Anda dapat
                      diakses oleh pihak ketiga manapun yang bekerja sama dengan
                      Kami. Untuk menghindari keraguan, Anda juga mengizinkan
                      Kami untuk mengungkapkan data pribadi Anda kepada setiap
                      otoritas (termasuk otoritas hukum) berdasarkan hukum dan
                      peraturan perundang-undangan yang berlaku. Kami tidak
                      bertanggung jawab atas setiap kerugian Anda akibat
                      penyalahgunaan oleh pihak ketiga atas data atau informasi
                      Anda yang telah diungkapkan berdasarkan ketentuan ini.
                      Anda memahami bahwa Kami dapat disyaratkan untuk
                      mengungkapkan data pribadi Anda kepada setiap otoritas
                      (termasuk otoritas hukum atau moneter) berdasarkan hukum
                      dan peraturan perundang-undangan yang berlaku. Kami akan
                      memiliki hak untuk menginvestigasi dan menuntut dalam hal
                      terjadi pelanggaran terhadap seluruh ketentuan di atas,
                      sepanjang yang dimungkinkan oleh hukum termasuk melibatkan
                      aparat penegak hukum. Kami memiliki hak untuk memonitor
                      akses Anda dalam Platform, untuk memastikan kepatuhan
                      dengan Ketentuan Penggunaan ini, atau untuk mematuhi
                      peraturan yang berlaku.
                    </li>
                  </ol>
                </div>
                <div class="row-syarat">
                  <p
                    class="title-content"
                  >
                    Pemesanan
                  </p>
                </div>
                <div class="row-syarat">
                  <ol
                   class="content-tnc"
                  >
                    <li>
                      Anda menjamin bahwa setiap informasi dan/atau identitas
                      yang Anda berikan kepada Kami sehubungan dengan pemesanan
                      merupakan informasi yang benar dan lengkap dan Kami tidak
                      bertanggung jawab atas kesalahan pesanan dalam hal
                      terdapat kesalahan identitas.
                    </li>
                    <li>
                      Saat melakukan pemesanan, Anda harus memilih dan/atau
                      memberikan informasi yang akurat dan lengkap mengenai
                      jenis, spesifikasi, kuantitas dan/atau setiap
                      karakteristik khusus dari produk yang dipesan. Kami tidak
                      akan bertanggung jawab atas kerugian yang disebabkan oleh
                      kesalahan pemesanan Anda.
                    </li>
                    <li>
                      Kami berhak untuk menolak pesanan Anda jika, menurut
                      penilaian Kami, Kami tidak dapat melakukan pengiriman
                      produk termasuk namun tidak terbatas karena produk tidak
                      tersedia, atau bahwa berdasarkan keterangan Platform dan
                      Layanan Kami, lokasi pengiriman pesanan Anda di luar
                      jangkauan pengiriman kami, atau dengan menerima pesanan
                      dari Anda, Anda akan melanggar Syarat dan Ketentuan ini
                      atau hukum dan peraturan perundang-undangan yang berlaku.
                    </li>
                  </ol>
                </div>
                <div class="row-syarat">
                  <p
                    class="title-content"
                  >
                    Harga dan Pembayaran
                  </p>
                </div>
                <div class="row-syarat">
                  <ol
                   class="content-tnc"
                  >
                    <li>
                      Seluruh harga produk yang terdapat dalam Platform Kami
                      adalah benar saat dipublikasikan. Namun, harga produk yang
                      ditampilkan dalam Platform dapat berubah dari waktu ke
                      waktu tergantung situasi dan kondisi bisnis. Sebagai
                      penyedia Platform, Kami akan mengubah harga yang terdaftar
                      disesuaikan dengan perubahan harga yang terjadi.
                    </li>
                    <li>
                      Anda hanya berkewajiban untuk membayar sesuai dengan
                      jumlah pesanan Anda sesuai yang tercantum pada saat proses
                      checkout. Anda juga dapat menggunakan promo atau voucher
                      yang tersedia untuk mendapatkan potongan harga atau
                      keuntungan lainnya. Perubahan terhadap harga pesanan Anda
                      tidak dapat terjadi pada saat Anda dalam proses checkout
                      dari Platform Kami.
                    </li>
                    <li>
                      Anda hanya dapat melakukan pembayaran atas pesanan Anda
                      melalui metode-metode pembayaran yang telah disediakan
                      dalam Platform Kami (dari waktu ke waktu dapat berubah),
                      yaitu: cash on delivery, transfer dan upload manual bukti
                      transfer.
                    </li>
                    <li>
                      Anda menjamin untuk menyediakan informasi mengenai detail
                      pembayaran secara lengkap dan akurat, serta memiliki saldo
                      atau limit yang cukup pada metode pembayaran yang Anda
                      pilih untuk dapat digunakan dalam pembayaran pesanan Anda.
                    </li>
                    <li>
                      Kami berhak menolak atau menunda untuk meneruskan
                      permintaan pembayaran Anda melalui Metode Pembayaran
                      karena alasan tertentu, termasuk namun tidak terbatas pada
                      adanya indikasi atau Kami mempunyai alasan yang cukup
                      untuk menduga adanya kecurangan, penipuan, pelanggaran
                      Ketentuan Penggunaan, pelanggaran atas peraturan
                      perundang-undangan yang berlaku termasuk yang terkait
                      dengan alat pembayaran menggunakan kartu, uang elektronik,
                      pemrosesan transaksi pembayaran, anti pencucian uang,
                      korupsi dan pencegahan pendanaan terorisme, atau tindakan
                      lain yang tidak wajar atau mencurigakan, termasuk belum
                      dipenuhinya kewajiban Anda kepada Kami.
                    </li>
                  </ol>
                </div>
                <div class="row-syarat">
                  <p
                    class="title-content"
                  >
                    Pengiriman
                  </p>
                </div>
                <div class="row-syarat">
                  <ol
                   class="content-tnc"
                  >
                    <li>
                      Kami melayani pengiriman di area Jakarta, Bogor, Depok,
                      Tangerang dan Bekasi (Jabodetabek) dan di 19 cabang Kami
                      di Indonesia
                    </li>
                    <li>
                      Setiap pesanan yang telah masuk dalam sistem akan segera
                      diproses dan dikirim melalui kurir yang telah disediakan
                      oleh Kami sesuai tanggal pesanan (diluar hari Minggu dan
                      hari libur nasional).
                    </li>
                    <li>
                      Waktu pengiriman akan dilakukan pada hari Senin-Sabtu
                      (diluar hari libur Nasional). Pemesanan dilakukan maksimal
                      H-1 hari pengiriman (delivery date), dengan ketentuan:
                      <br />a. untuk Senin-Jumat pemesanan dilakukan maksimal
                      sebelum jam 17.00 WIB;dan <br />b. untuk hari Sabtu
                      pemesanan dilakukan maksimal sebelum jam 12.00 WIB
                    </li>
                    <li>
                      Anda akan mendapatkan gratis biaya pengiriman pesanan dari
                      Kami jika memenuhi minimum nilai order yang ditetapkan.
                    </li>
                    <li>
                      Anda menjamin bahwa setiap informasi dan/atau identitas
                      yang Anda berikan kepada Kami sehubungan dengan pengiriman
                      merupakan informasi yang benar dan lengkap. Sehingga, Kami
                      tidak bertanggung jawab atas kesalahan pengiriman dalam
                      hal terdapat kesalahan informasi dari Anda. Dalam hal ini,
                      Anda harus bertanggung jawab dan memberikan kompensasi
                      yang diperlukan kepada Kami apabila ada.
                    </li>
                    <li>
                      Kami tidak bertanggung jawab kepada Anda atas kerugian,
                      kewajiban, biaya, kerusakan, atau pengeluaran yang timbul
                      dari keterlambatan pengiriman pesanan, kecuali jika
                      terbukti bahwa keterlambatan tersebut diakibatkan oleh
                      kesalahan Kami secara langsung.
                    </li>
                  </ol>
                </div>
                <div class="row-syarat">
                  <p
                    class="title-content"
                  >
                    Penolakan, Pembatalan, dan Pengembalian Dana
                  </p>
                </div>
                <div class="row-syarat">
                  <ol
                   class="content-tnc"
                  >
                    <li>
                      Dalam hal produk yang dipesan dan dibayar tidak tersedia,
                      pesanan terhadap produk tersebut akan dibatalkan secara
                      otomatis melalui Platform Kami. Kami akan melakukan
                      pengembalian dana berupa deposit untuk dikurangi ke
                      pembelian selanjutnya.
                    </li>
                    <li>
                      Dalam hal terdapat pesanan yang rusak, Anda berhak menolak
                      produk tersebut dengan memberitahukan melalui mekanisme
                      penyampaian keluhan dapat disampaikan pada bagian Contact
                      Us atau pada kolom feedback Sukanda OneLink
                      <a href="https://open.sukandaonelink.com/contact-us"
                        >https://open.sukandaonelink.com/contact-us</a
                      >, dengan menjelaskan kondisi barang saat diterima dengan
                      menyertakan bukti foto produk terkait dan melakukan
                      konfirmasi ke tim Kami, setelah tim Kami memeriksa dan
                      memberikan persetujuan (approval) bahwa produk dapat
                      ditolak, maka Anda dapat menolak produk tersebut ditempat.
                      Setelah laporan tersebut, Anda harus memberikan konfirmasi
                      kepada Kami mengenai pengiriman ulang produk. Apabila Anda
                      memberikan konfirmasi pengiriman ulang, produk akan
                      dikirimkan keesokan harinya, namun apabila tidak maka dana
                      pembayaran yang sudah masuk akan tersimpan sebagai deposit
                      untuk pembelian selanjutnya..
                    </li>
                    <li>
                      Dalam hal Anda menerima produk yang salah dengan yang
                      dipesan dan dibayar karena kesalahan Kami, Anda dapat
                      memberitahukan hal tersebut melalui mekanisme penyampaian
                      keluhan dengan menyertakan bukti foto terkait kepada sales
                      Kami atau dapat melalui Customer Service Kami dalam waktu
                      maksimal 1x24 jam setelah produk diterima, dengan
                      ketentuan bahwa kondisi produk yang salah dalam keadaan
                      baik dan Anda wajib menyimpan produk yang salah dengan
                      penyimpanan yang sesuai dengan produk tersebut sampai
                      dengan produk ditarik oleh tim Kami dengan membawa Surat
                      Tarikan. Apabila Anda membutuhkan produk yang dipesan pada
                      pemesanan awal (“Produk Pertama”) dalam waktu dekat, maka
                      Anda dapat melakukan pemesanan ulang untuk Produk Pertama
                      tersebut pada saat atau setelah pelaporan keluhan
                      dilakukan, ketentuan minimum order untuk pengiriman Produk
                      Pertama tidak berlaku. Dengan ini Anda setuju bahwa atas
                      pelaporan keluhan yang dilakukan untuk produk yang salah,
                      nilai produk yang salah akan dijadikan deposit untuk
                      pembelian selanjutnya.
                    </li>
                    <li>
                      Dengan ini Anda setuju bahwa Kami hanya menerima
                      penyampaian keluhan paling lambat 1x24 jam setelah
                      produk-produk yang Anda pesan sampai ke tempat Anda,
                      sehingga Anda membebaskan tanggung jawab Kami atas
                      produk-produk pesanan Anda setelah jangka waktu tersebut.
                      Dan terkait dengan pengembalian dana atas produk yang
                      rusak atau salah dalam jangka waktu keluhan tersebut di
                      atas akan dikembalikan dalam bentuk deposit.
                    </li>
                  </ol>
                </div>
                <div class="row-syarat">
                  <p
                    class="title-content"
                  >
                    Penutupan Akun
                  </p>
                </div>
                <div class="row-syarat">
                  <ol
                   class="content-tnc"
                  >
                    <li>
                      Apabila Anda tidak menggunakan Platform sesuai dengan
                      tujuan penggunaannya, melanggar Syarat dan Ketentuan ini
                      dan/atau peraturan perundang-undangan yang berlaku, Kami
                      berhak membekukan atau mengakhiri penggunaan Platform
                      Anda.
                    </li>
                    <li>
                      Anda memiliki kewajiban untuk menjaga keamanan dan
                      kerahasiaan data yang berkaitan dengan akun Anda, sehingga
                      dalam hal terjadi pengungkapan atau penggunaan data
                      terkait yang tidak sah atau tanpa kewenangan Anda, atau
                      peretasan akun, Kami dapat melakukan penutupan akun Anda.
                    </li>
                    <li>
                      Anda berhak untuk memilih berhenti, baik untuk sementara
                      maupun selamanya, dalam menggunakan Platform setiap saat
                      dengan membatalkan dan menutup akun Anda.
                    </li>
                    <li>
                      Untuk menutup akun, Anda wajib menghubungi Kami melalui
                      mekanisme penyampaian pesan ke
                      <a href="https://open.sukandaonelink.com/contact-us"
                        >https://open.sukandaonelink.com/contact-us</a
                      >
                      dan mengajukan permohonan penutupan akun. Kami berhak
                      untuk melakukan proses verifikasi data dengan menghubungi
                      Anda sebelum melakukan penutupan akun.
                    </li>
                  </ol>
                </div>
                <div class="row-syarat">
                  <p
                    class="title-content"
                  >
                    Pembatasan Tanggung Jawab dan Ganti Rugi
                  </p>
                </div>
                <div class="row-syarat">
                  <ol
                   class="content-tnc"
                  >
                    <li>
                      Kami tidak bertanggung jawab kepada Anda atau orang lain
                      yang menggunakan Layanan melalui akun Anda untuk biaya,
                      bunga, kerusakan atau kerugian dalam segala jenis atau
                      bentuk apapun (termasuk cedera pribadi, tekanan emosional
                      dan hilangnya data, barang, pendapatan, laba, penggunaan
                      atau keuntungan ekonomis lainnya), kecuali untuk kerugian
                      langsung, yang timbul atau sehubungan dengan akun Anda
                      dalam Platform Kami, yang dapat dibuktikan terjadi karena
                      kelalaian berat atau pelanggaran Kami atas Syarat dan
                      Ketentuan ini. Setiap tuntutan terhadap Kami dalam hal
                      apapun oleh Anda, tanggung jawab Kami hanya terbatas pada
                      jumlah total yang ternyata secara tertulis dibayar oleh
                      dan/atau terutang pada Anda ketika menggunakan Layanan
                      Sukanda OneLink.
                    </li>
                    <li>
                      Tanggung jawab untuk keputusan yang Anda buat untuk
                      menggunakan Layanan yang disediakan melalui Platform Kami
                      merupakan tanggung jawab Anda dan melekat seutuhnya pada
                      Anda. Anda secara tegas mengesampingkan dan melepaskan
                      Kami dari setiap dan semua kewajiban, tuntutan, penyebab
                      tindakan, atau kerusakan yang timbul dari penggunaan
                      Layanan dan Platform Kami.
                    </li>
                    <li>
                      Dengan mendaftarkan diri dan menggunakan Platform Kami,
                      Anda setuju bahwa Anda akan mengganti rugi dan membebaskan
                      PT Sukanda Djaya, afiliasi, dan masing-masing dari
                      pejabat, direktur, komisaris, karyawan, pengacara dan agen
                      Sukanda OneLink dari dan terhadap setiap dan semua klaim,
                      biaya, kerusakan, kerugian, kewajiban dan biaya (termasuk
                      biaya advokat) yang timbul dari atau sehubungan dengan:
                      <br />a. pelanggaran Anda atas Syarat dan Ketentuan,
                      Kebijakan Privasi, dan/atau ketentuan hukum dan peraturan
                      perundang-undangan yang berlaku, baik yang dirujuk dalam
                      Syarat dan Ketentuan ini atau tidak; <br />
                      b. pelanggaran Anda terhadap hak-hak pihak ketiga terkait
                      penggunaan Platform yang bukan diakibatkan oleh Kami;
                      <br />c. penggunaan atau penyalahgunaan Platform dan
                      Layanan yang tersedia di dalamnya oleh Anda atau pihak
                      lain yang menggunakan akun Anda; atau <br />d. pengakhiran
                      akun Sukanda OneLink Anda berdasarkan hal-hal yang diatur
                      dalam Penutupan Akun di atas.
                    </li>
                  </ol>
                </div>

                <div class="row-syarat">
                  <p class="content-tnc"
                  >
                    Ketentuan ganti rugi ini akan tetap berlaku terlepas dari
                    penutupan akun Sukanda OneLink Anda.
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                    class="title-content"
                  >
                    Hak Kekayaan Intelektual
                  </p>
                </div>
                <div class="row-syarat">
                  <ol
                   class="content-tnc"
                  >
                    <li>
                      Platform Kami, termasuk nama dan logonya, kode, desain,
                      teknologi, model bisnis, dilindungi oleh hak cipta, merek,
                      dan hak kekayaan intelektual lainnya yang tersedia
                      berdasarkan hukum Republik Indonesia yang telah terdaftar
                      atas nama Kami. Kami (dan pihak yang memperoleh lisensi
                      dari Kami, jika berlaku) memiliki seluruh hak dan
                      kepentingan atas Platform Kami, termasuk seluruh hak
                      kekayaan intelektual terkait dengan seluruh fitur Layanan
                      yang terdapat di dalamnya dan hak kekayaan intelektual
                      lainnya yang terkait.
                    </li>
                    <li>
                      Tunduk pada kepatuhan Anda pada Syarat dan Ketentuan ini,
                      Kami memberikan kepada Anda lisensi terbatas,
                      non-eksklusif, yang tidak dapat dipindahtangankan, tidak
                      dapat dialihkan, dan tidak dapat disublisensikan dan yang
                      dapat ditarik kembali untuk mengunduh dan menggunakan
                      perangkat lunak yang digunakan dalam Aplikasi Sukanda
                      OneLink pada Ponsel Pintar atau perangkat elektonik
                      lainnya yang Anda miliki atau kontrol untuk kebutuhan
                      Anda.
                    </li>
                    <li>
                      Anda tidak diperkenankan (i) menyalin, memodifikasi,
                      mengadaptasi, menerjemahkan, membuat karya turunan dari,
                      mendistribusikan, memberikan lisensi, menjual,
                      mengalihkan, menampilkan di muka umum, membuat ulang,
                      mentransmisikan, memindahkan, menyiarkan, menguraikan,
                      atau membongkar bagian manapun dari atau dengan cara lain
                      mengeksploitasi Platform Sukanda OneLink (termasuk Layanan
                      di dalamnya) yang dilisensikan kepada Anda, kecuali
                      sebagaimana diperbolehkan dalam Syarat dan Ketentuan ini,
                      (ii) memberikan lisensi, mensublisensikan, menjual,
                      menjual kembali, memindahkan, mengalihkan,
                      mendistribusikan atau mengeksploitasi secara komersial
                      atau membuat tersedia kepada pihak ketiga Platform Sukanda
                      OneLink atau perangkat lunak dengan cara; (iii)
                      menciptakan "link" internet ke Platform Sukanda OneLink
                      atau "frame" atau "mirror" setiap perangkat lunak pada
                      server lain atau perangkat nirkabel atau yang berbasis
                      internet; (iv) merekayasa ulang atau mengakses perangkat
                      lunak Kami untuk (a) membangun produk atau layanan
                      tandingan, (b) membangun produk dengan menggunakan ide,
                      fitur, fungsi atau grafis sejenis Platform Sukanda
                      OneLink, atau (c) menyalin ide, fitur, fungsi atau grafis
                      Platform Sukanda OneLink, (v) meluncurkan program otomatis
                      atau script, termasuk, namun tidak terbatas pada, web
                      spiders, web crawlers, web robots, web ants, web indexers,
                      bots, virus atau worm, atau segala program apapun yang
                      mungkin membuat beberapa permintaan server per detik, atau
                      menciptakan beban berat atau menghambat operasi dan/atau
                      kinerja Platform Sukanda OneLink, (vi) menggunakan robot,
                      spider, pencarian situs/aplikasi pengambilan kembali, atau
                      perangkat manual atau otomatis lainnya atau proses untuk
                      mengambil, indeks, "tambang data" (data mine), atau dengan
                      cara apapun memperbanyak atau menghindari struktur
                      navigasi atau presentasi dari aplikasi atau isinya; (vii)
                      menerbitkan, mendistribusikan atau memperbanyak dengan
                      cara apapun materi yang dilindungi hak cipta, merek
                      dagang, atau informasi yang Kami miliki lainnya tanpa
                      memperoleh persetujuan terlebih dahulu dari Kami atau
                      pemilik hak yang melisensikan hak-nya kepada Kami, (viii)
                      menghapus setiap hak cipta, merek dagang atau
                      pemberitahuan hak milik lainnya yang terkandung dalam
                      Platform Sukanda OneLink.
                    </li>
                  </ol>
                </div>

                <div class="row-syarat">
                  <p
                    class="title-content"
                  >
                    Hubungi Kami
                  </p>
                </div>
                <div class="row-syarat">
                  <p class="content-tnc"
                  >
                    Kami dengan senang hati akan menerima pesan, keluhan dan
                    saran Anda, serta berusaha menanggapi dan menyelesaikan
                    segala keluhan Anda sebaik dan sesegera mungkin. Segala
                    keluhan dapat ditujukan ke
                    <a href="https://open.sukandaonelink.com/contact-us"
                      >https://open.sukandaonelink.com/contact-us</a
                    >
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                    class="title-content"
                  >
                    Lain-Lain
                  </p>
                </div>
                <div class="row-syarat">
                  <ol
                   class="content-tnc"
                  >
                    <li>
                      Anda tidak dapat mengalihkan hak dan kewajiban Anda
                      berdasarkan Syarat dan Ketentuan ini tanpa persetujuan
                      sebelumnya dari Kami.
                    </li>
                    <li>
                      Dalam hal terdapat istilah dalam Syarat dan Ketentuan yang
                      dianggap tidak sah, tidak berlaku, atau tidak dapat
                      dilaksanakan, baik secara keseluruhan atau sebagian
                      berdasarkan ketentuan perundang-undangan, istilah atau
                      bagian dari istilah tersebut akan dianggap bukan bagian
                      dari Syarat dan Ketentuan ini, namun keabsahan dan
                      keberlakuan terhadap yang lainnya dari Syarat dan
                      Ketentuan akan tetap sah.
                    </li>
                    <li>
                      Syarat dan Ketentuan ini diatur dan dibuat berdasarkan
                      Hukum Republik Indonesia. Kami dan Anda dengan ini memilih
                      yurisdiksi kepaniteraan Pengadilan Negeri Jakarta Utara.
                    </li>
                    <li>
                      Kami berhak mengubah Syarat dan Ketentuan ini
                      sewaktu-waktu.
                    </li>
                    <li>
                      Dalam hal terjadi perubahan secara substantif dari Syarat
                      dan Ketentuan ini, Kami akan mempublikasi kepada pengguna.
                      Jika Anda melanjutkan untuk menggunakan dan mengakses
                      Platform setiap publikasi tersebut, Anda akan dianggap
                      menyetujui perubahan yang terjadi.
                    </li>
                    <li>
                      Anda memahami dan menyetujui bahwa (dengan atau tanpa
                      pemberitahuan) kami dapat memperbarui, memodifikasi atau
                      menghentikan Platform Sukanda OneLink (atau akses Anda ke
                      mereka) dari waktu ke waktu, termasuk dengan mendorong
                      pembaruan pada (atau menghapus fungsionalitas atau akses
                      dari) salah satu fitur pada Platform Sukanda OneLink yang
                      telah Anda instal pada perangkat Anda.
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <div
            class="yCmsComponent regist-left-content-component reorder-containers"
            style="order: 1;"
          >
            <div
              class="banner__component simple-banner"
              style="width: 100%; height: auto;"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
